import { CustomerListToolbar } from 'components';

export function UsersPage() {
  return (
    <div className={'mt-8 w-full px-4'}>
      <CustomerListToolbar />
    </div>
  );
}
